import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_maple-land-dev/artifacts/5i2dxxuh_koro%20living%20logo4.png";

const navLinks = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About' },
  { href: '/projects', label: 'Projects' },
  { href: '/contact', label: 'Contact Us' },
];

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground relative z-10" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={LOGO_URL} 
                alt="Koro Living" 
                className="h-52 w-auto"
              />
            </Link>
            <p className="text-primary-foreground/70 text-sm leading-relaxed max-w-sm">
              Property & Land Developers building quality homes and developing land 
              for a better future in Manawatu, New Zealand.
            </p>
          </div>
          
          {/* Navigation Column */}
          <div className="md:col-span-3">
            <h4 className="font-semibold text-sm tracking-wide uppercase mb-6">
              Navigation
            </h4>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm"
                  data-testid={`footer-link-${link.label.toLowerCase().replace(' ', '-')}`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
          
          {/* Contact Column */}
          <div className="md:col-span-4">
            <h4 className="font-semibold text-sm tracking-wide uppercase mb-6">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-primary-foreground/50" />
                <span className="text-primary-foreground/70 text-sm">
                  Manawatu, New Zealand
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary-foreground/50" />
                <a 
                  href="mailto:info@koroliving.co.nz" 
                  className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm"
                >
                  info@koroliving.co.nz
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary-foreground/50" />
                <a 
                  href="tel:+64220716315" 
                  className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm"
                >
                  +64 22 071 6315
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-primary-foreground/50 text-xs">
            © {new Date().getFullYear()} Koro Living. All rights reserved.
          </p>
          <p className="text-primary-foreground/50 text-xs">
            Property & Land Developers | New Zealand
          </p>
        </div>
      </div>
    </footer>
  );
}
